import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TramiteSicProteccionConsumidorDto } from '../../../../../dto/tramites/tramite-sic-proteccion-consumidor.dto';
import { PersonaDto } from '../../../../../dto/tramites/persona.dto';
import { Constants } from '../../../../../constants/constants';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest } from 'rxjs';
import { AlertaModalService } from "../../../../../services/util/alerta-modal.service";

@Component({
  selector: 'app-notificaciones',
  templateUrl: './notificaciones.component.html',
  styleUrl: './notificaciones.component.scss',
})
export class NotificacionesComponent implements OnInit, OnChanges {
  @Output() enviarTramite = new EventEmitter<{
    tramite: TramiteSicProteccionConsumidorDto;
    enviarCorreoDemandado: boolean;
    event: Event;
  }>();

  @Output() guardarSinEnviarTramite = new EventEmitter<{
    tramite: TramiteSicProteccionConsumidorDto;
    event: Event;
  }>();

  @Output() volver = new EventEmitter<number>();

  demandantesForm: FormGroup | null = null;
  demandadosForm: FormGroup | null = null;

  @Input() tramiteSic?: TramiteSicProteccionConsumidorDto;
  // Multilenguaje
  proconText: any = {};
  comunText: any = {};
  alertaText: any = {};

  confirmacionEnvio: boolean = false;
  enviarCorreoDemandado: boolean = false;
  pesoTotalArchivosMB: string = '0.00';
  seleccionAceptoRechazoEnvio = false;
  constructor(
    private fb: FormBuilder,
    private readonly translate: TranslateService,
    private readonly alertaModalService: AlertaModalService,
  ) { }

  ngOnInit() {
    this.demandantesForm = this.fb.group({
      demandantes: this.fb.array([]),
    });

    this.demandadosForm = this.fb.group({
      demandados: this.fb.array([]),
    });
    combineLatest([
      this.translate.stream('tramites'),
      this.translate.stream('comun-label'),
      this.translate.stream('alertas'),
    ]).subscribe(([tramitesText, comunLabelText, alertas]) => {
      // Procesar el texto de 'tramites'
      for (const key of Object.keys(tramitesText)) {
        this.proconText[key] = tramitesText[key];
      }

      // Procesar el texto de 'comun-label'
      for (const key of Object.keys(comunLabelText)) {
        this.comunText[key] = comunLabelText[key];
      }
      for (const key of Object.keys(alertas)) {
        this.alertaText[key] = alertas[key];
      }
      this.cargarDemandantes();
      this.cargarDemandados();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['tramiteSic'] && changes['tramiteSic'].currentValue) {
      this.tramiteSic = changes['tramiteSic']
        .currentValue as TramiteSicProteccionConsumidorDto;
    }
  }

  get demandantes(): FormArray {
    return this.demandantesForm?.get('demandantes') as FormArray;
  }

  get demandados(): FormArray {
    return this.demandadosForm?.get('demandados') as FormArray;
  }

  cargarDemandantes() {
    const listaDemandantes = this.tramiteSic?.demandante;

    listaDemandantes?.forEach(item => {
      this.demandantes.push(this.creardemandantesForm(item));
    });
  }

  cargarDemandados() {
    const listaDemandados = this.tramiteSic?.demandado;

    if (listaDemandados?.length) {
      // Llenamos el array de formularios
      listaDemandados.forEach(item => {
        this.demandados.push(this.creardemandadosForm(item));
      });
    }
  }

  creardemandantesForm(item: PersonaDto): FormGroup {
    return this.fb.group({
      id: [item.id],
      correo: [
        item.correoElectronico,
        [
          Validators.required,
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
        ],
      ],
      direccion: [
        item.direccionPersona
          ? item.direccionPersona[0].direccionNotificacion
          : null,
        [
          Validators.required,
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
      ],
    });
  }

  creardemandadosForm(item: PersonaDto): FormGroup {
    return this.fb.group({
      id: [item.id],
      correo: [
        item.correoElectronico,
        [
          Validators.required,
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
        ],
      ],
      direccion: [
        item.direccionPersona
          ? item.direccionPersona[0].direccionNotificacion
          : null,
        [
          Validators.required,
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
      ],
    });
  }

  validarAntesDeContinuar(event: Event, tipo: number) {

    const validForms =
      this.demandantesForm?.valid &&
      this.demandadosForm?.valid;


    if (!validForms) {

      // marcar errores visibles
      this.demandantesForm?.markAllAsTouched();
      this.demandadosForm?.markAllAsTouched();

      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['form_invalid']
      );

      return;
    }

    if (!this.confirmacionEnvio) {
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['ley_2213']
      );
      return;
    }

    if (!this.seleccionAceptoRechazoEnvio) {
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['envio_demanda']
      );
      return;
    }

    // Todo válido → ejecuta flujo original
    this.continuar(event, tipo);
  }
  //TIPO1: ENVIAR SIN GUARDAR, TIPO2:ENVIAR
  continuar(e: Event, tipo: number) {
    const demandantes: string[] = [];
    const demandados: string[] = [];

    const valoresDemandantes = this.demandantes.value;
    const valoresDemandados = this.demandados.value;

    for (const demandante of valoresDemandantes) {
      const item = `${demandante['id']};${demandante['direccion']};${demandante['correo']}`;
      demandantes.push(item);
    }

    for (const demandado of valoresDemandados) {
      const item = `${demandado['id']};${demandado['direccion']};${demandado['correo']}`;
      demandados.push(item);
    }

    const tramite: TramiteSicProteccionConsumidorDto = {
      notificacionesDemandante: demandantes,
      notificacionesDemandado: demandados,
    };

    this.enviar(e, tramite, tipo);
  }

  enviar(e: Event, tramite: TramiteSicProteccionConsumidorDto, tipo: number) {
    if (tipo === 1) {
      this.guardarSinEnviarTramite.emit({ tramite: tramite, event: e });
    }
    if (tipo === 2) {
      this.enviarTramite.emit({ tramite: tramite, enviarCorreoDemandado: this.enviarCorreoDemandado, event: e });
    }
  }

  anterior() {
    let paso = +JSON.parse(sessionStorage.getItem(Constants.PASOS)!);
    let cargaronNuevosArchivos = JSON.parse(sessionStorage.getItem(Constants.ARCHIVOS_SIC_PROCON_PASO_SIETE)!);

    if (paso) {
      paso--;
      sessionStorage.setItem(Constants.PASOS, JSON.stringify(paso));
    }

    this.volver.emit(7);
  }

  get correoDemandado(): string {
    const correos = this.tramiteSic?.demandado?.map((elem) => elem.correoElectronico);
    return correos!.length > 1
      ? `${correos!.slice(0, -1).join(', ')}, ${correos!.slice(-1)}`
      : `${correos![0]}`
  }

  get nombreDemandado(): string {
    const nombres = this.tramiteSic?.demandado?.map((elem) =>
      elem.idTipoPersona === Constants.TIPO_PERSONA.NATURAL
        ? `${elem.primerNombre ?? ''} ${elem.segundoNombre ?? ''} ${elem.primerApellido ?? ''} ${elem.segundoApellido ?? ''}`.trim()
        : elem.razonSocial
    );

    return nombres!.length > 1
      ? `${nombres!.slice(0, -1).join(', ')}, ${nombres!.slice(-1)}`
      : `${nombres![0]}`;
  }

  rechazarEnvio() {
    this.seleccionAceptoRechazoEnvio = true;
    this.enviarCorreoDemandado = false;
    this.alertaModalService.exito(
      this.comunText['accion-cancelada'],
      this.comunText['rechazo-envio']
    );
  }

  aceptarEnvio() {
    this.seleccionAceptoRechazoEnvio = true;
    this.enviarCorreoDemandado = true;
    this.alertaModalService.exito(
      this.comunText['envio-confirmado'],
      this.comunText['acepta-copia']
    );
  }

  get pesoArchivos(): string {
    return this.pesoTotalArchivosMB;
  }
}
